import Global from '../../js/constant.js'
import axios from 'axios'

const follows = {
  state: {
    accountFollows : [],
    circleFollows : [],
    followers: {},
  },
  getters: {
    accountFollows(state) { return state.accountFollows },
    circleFollows(state) { return state.circleFollows },
    followers(state) { return state.followers },
  },
  mutations: {
    setAccountFollows(state, value) {
      state.accountFollows = value
      state.followCount = value.length + value.length
    },
    setCircleFollows(state, value) {
      state.circleFollows = value
      state.followCount = value.length + value.length
    },
    setFollowers(state, value) {
      state.followers = value
    },
  },
  actions: {
    getAccountFollows ({commit}, account) {
      if (!account) return 
      axios.post(Global.url.api_account_follows_search, { account_id: account.id })
      .then(res => {
        if (res.data.status == Global.api_status.success) {
          commit('setAccountFollows', res.data.account_follows)
        }
      }).catch(error => {
        console.dir(error)
      })
    },
    getCircleFollows ({commit}, account) {
      if (!account) return 
      axios.post(Global.url.api_circle_follows_search, { account_id: account.id })
      .then(res => {
        if (res.data.status == Global.api_status.success) {
          commit('setCircleFollows', res.data.circle_follows)
        }
      }).catch(error => {
        console.dir(error)
      })
    },
    getFollowers ({commit}, account) {
      if (!account) return 
      axios.post(Global.url.api_account_followers_search, {account_id: account.id})
      .then (res => {
        if (res.data.status == Global.api_status.success) {
          commit('setFollowers', res.data.account_follows)
        }
      })
      .catch (error => { console.log(error) })
    },
  },
  modules: {}
}
export default follows